/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiAPauseShapeIcon16Light } from './MediaUiAPauseShapeIcon16Light';
import { MediaUiAPauseShapeIcon16Regular } from './MediaUiAPauseShapeIcon16Regular';
import { MediaUiAPauseShapeIcon16Solid } from './MediaUiAPauseShapeIcon16Solid';
import { MediaUiAPauseShapeIcon20Light } from './MediaUiAPauseShapeIcon20Light';
import { MediaUiAPauseShapeIcon20Regular } from './MediaUiAPauseShapeIcon20Regular';
import { MediaUiAPauseShapeIcon20Solid } from './MediaUiAPauseShapeIcon20Solid';
import { MediaUiAPauseShapeIcon24Regular } from './MediaUiAPauseShapeIcon24Regular';
import { MediaUiAPauseShapeIcon24Solid } from './MediaUiAPauseShapeIcon24Solid';
import { MediaUiAPauseShapeIcon32Regular } from './MediaUiAPauseShapeIcon32Regular';
import { MediaUiAPauseShapeIcon64Regular } from './MediaUiAPauseShapeIcon64Regular';
var sizes = {
    16: {
        light: MediaUiAPauseShapeIcon16Light,
        regular: MediaUiAPauseShapeIcon16Regular,
        solid: MediaUiAPauseShapeIcon16Solid,
    },
    20: {
        light: MediaUiAPauseShapeIcon20Light,
        regular: MediaUiAPauseShapeIcon20Regular,
        solid: MediaUiAPauseShapeIcon20Solid,
    },
    24: {
        regular: MediaUiAPauseShapeIcon24Regular,
        solid: MediaUiAPauseShapeIcon24Solid,
    },
    32: {
        regular: MediaUiAPauseShapeIcon32Regular,
    },
    64: {
        regular: MediaUiAPauseShapeIcon64Regular,
    },
};
export var MediaUiAPauseShapeIcon = forwardRef('MediaUiAPauseShapeIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
